export class CombinedAbortController {
    constructor(abortSignals) {
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abortController = new AbortController();
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        abortSignals.forEach((signal) => {
            if (!signal) {
                return;
            }
            if (signal.aborted) {
                self.abortController.abort();
            }
            signal.addEventListener('abort', function handleAbort() {
                signal.removeEventListener('abort', handleAbort);
                self.abortController.abort();
            });
        });
    }
    get signal() {
        return this.abortController.signal;
    }
}
//# sourceMappingURL=CombinedAbortController.js.map